import React from "react";
import "../../styles/ServicesSection/ServiceCard.scss";
import { useMediaQuery } from "@mui/material";

export interface Service {
  name: string;
  icon: string;
  description: string;
}

export const ServiceCard: React.FC<{
  title: string;
  icon: string;
  description: string;
}> = ({ title, description, icon }) => {
  const isMobile = useMediaQuery("(max-width:800px)");
  return (
    <div
      className="service"
      style={{ height: isMobile ? "8.2rem" : "24.5rem" }}
    >
      <div className="service-icon">
        <img src={`/images/${icon}.svg`} alt={title} />
      </div>
      <div className="service-content">
        <h2>{title}</h2>
        {/*   <p>{description}</p> */}
      </div>
    </div>
  );
};
